<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="pull-right">
        <div class="btn-close" @click="close"></div>
      </div>
      <div class="tab" v-if="myHtml">
        <iframe :srcdoc="modifiedHtml" />
      </div>
      <div class="tab" v-if="isJson">
        <json-viewer :value="myJson"></json-viewer>
      </div>
    </div>
  </div>
</template>

<script>
import JsonViewer from 'vue-json-viewer';

export default {
  name: 'htmlViewer',
  data() {
    return {
      customHtml:
        '<style>::-webkit-scrollbar{width:5px;height:5px}::-webkit-scrollbar-track{background:#ffff;border-radius:10px}::-webkit-scrollbar-thumb{background:rgb(117 117 117);border-radius:10px}::-webkit-scrollbar-thumb:hover{background:#555}::-webkit-scrollbar-track{-webkit-box-shadow:none!important;background-color:transparent}::-webkit-scrollbar{width:7px!important;background-color:transparent}::-webkit-scrollbar-thumb{background-color:transparent}</style>',
    };
  },
  props: {
    myHtml: String,
    myJson: {
      type: Object,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  computed: {
    modifiedHtml() {
      return this.myHtml + this.customHtml;
    },
    isJson() {
      return this.myJson && Object.keys(this.myJson).length;
    },
  },
  components: {
    JsonViewer,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-fullscreen {
  padding: 20px;
  background: #ffffff;
  display: block;
  width: 100%;
  height: 900px;
  text-align: center;
  margin-left: -14px;
  top: 0;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 70%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: fixed;
  left: 15%;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  height: 90%;
  overflow-y: scroll;
}

.modal iframe {
  width: 100%;
  height: 100%;
  border: none;
}

h1 {
  padding-top: 60px;
  color: #313745;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.12px;
  line-height: 41px;
  text-align: center;
  display: block;
  width: 860px;
  margin: 0 auto 40px;
  border: 0;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  position: relative;
  z-index: 1;
  -webkit-font-smoothing: antialiased;
  text-transform: none;
  margin-bottom: 20px;
  font-size: 38px;
  padding-bottom: 6px;
}

h2 {
  color: #313745;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.16px;
  line-height: 19px;
  padding-bottom: 55px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  height: 96%;
}

.group-wrapper {
  overflow: auto;
}

.modal > form {
  margin: 0 20%;
}

.modal > form > h3 {
  color: #22252b;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 16px;
  text-align: left;
  margin-top: 35px;
}

.modal > h4 {
  color: rgba(85, 93, 109, 0.4);
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding-bottom: 55px;
}

input {
  float: none;
  text-align: center;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding: 15px 20px 15px 20px;
  width: 290px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 22px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 52px;
  width: 100%;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #7e8890;
  color: #22252b;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.23px;
  line-height: 16px;
  padding: 15px 20px 15px 20px;
  text-align: left;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 400px;
  width: 500px;
  overflow: hidden;
}

::placeholder {
  color: #e3e3e3;
  opacity: 1;
}

button.default {
  color: #464d5d;
  background: #fff;
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

.pull-right {
  float: right;
  position: relative;
  margin-top: 15px;
  margin-right: 15px;
  z-index: 2;
}

.pull-left {
  float: left;
  z-index: 2;
  height: 30px;
  margin-top: 10px;
  margin-left: 15px;
  position: fixed;
}

.modal .btn-back {
  width: 23px;
  cursor: pointer;
}

.item {
  height: 175px;
}

.group-wrapper .item {
  height: 175px;
}

.group-wrapper {
  max-width: 960px;
  margin: 0 auto 0px;
  text-align: center;
  margin-top: 5px;
  overflow: auto;
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
}

.group-wrapper.category {
  width: 500px;
}

.group-wrapper.category.big {
  width: fit-content;
  margin-bottom: 29px;
}

.group-wrapper.big .item-wrapper .img-wrapper {
  height: 200px;
  margin-top: 80px;
  margin-bottom: 28px;
}

.group-wrapper.big .item-wrapper .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper:hover .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper.active .img-wrapper {
  filter: none;
}

.group-wrapper .item-wrapper.active {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.group-wrapper .item-wrapper:hover {
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.group-wrapper .item-wrapper .img-wrapper {
  filter: grayscale(82%) hue-rotate(246deg) opacity(30%);
}

.group-wrapper.big .item-wrapper {
  width: 315px;
  height: 482px;
  margin: 37px;
}

.group-wrapper .item-wrapper {
  display: inline-block;
  width: 212px;
  height: 230px;
  margin: 10px;
  opacity: 1;
  cursor: pointer;
  text-align: -webkit-match-parent;
  box-shadow: none;
  overflow: hidden;
}

.group-wrapper .img-wrapper {
  width: 100%;
  height: 130px;
}

.group-wrapper input {
  display: initial;
}

.group-wrapper .icon {
  position: absolute;
  width: 43%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  float: none;
  background-color: #fff;
  padding: 18px 6px 8px 6px;
}

.group-wrapper.big .icon {
  width: 300px;
}

.group-wrapper .item-wrapper h2 {
  color: #434c5e;
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.16px;
  line-height: 19px;
  padding-bottom: 0px;
}

.footer {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
  height: 100px;
  margin-bottom: 80px;
}

button {
  display: block;
  width: 180px;
  height: 44px;
  margin: 0 auto 80px;
  background: none;
  border: 0;
  border-radius: 100px;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  color: inherit;
  letter-spacing: 1px;
  -webkit-transition: background 0.2s ease;
  transition: background 0.2s ease;
  cursor: pointer;
  border: 1px solid #ccc;
}

.footer > button {
  background: #fb3467;
  color: #fff;
  border: none;
}

.footer > button.disabled {
  background-color: rgba(224, 0, 90, 0.3);
  cursor: unset;
}

.group-wrapper .item-wrapper .description {
  font-family: 'SF UI Text', -apple-system, system-ui, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  text-transform: none;
  color: #7b8496;
  -webkit-font-smoothing: antialiased;
  max-width: 100%;
  margin: 0px 13px 0px 13px;
  opacity: 0;
  transform: translateY(15px);
  transition: 0.2s ease;
}

.group-wrapper.big .item-wrapper .description {
  transform: translateY(5px);
  opacity: 1;
  margin-bottom: 25px;
}

.group-wrapper.big .item-wrapper:hover .description {
  transform: translateY(0);
  opacity: 1;
  margin-bottom: 15px;
}

.group-wrapper .item-wrapper:hover .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.group-wrapper .item-wrapper.active .description {
  opacity: 1;
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.toggle-list-wrapper {
  width: 100%;
  left: 0px;
  max-width: unset;
  padding-top: 10px;
  top: -35px;
}

.toggle-list-wrapper .item {
  height: 30px;
}

.toggle-list-wrapper .item .label {
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  font-size: 14px;
}

input {
  cursor: text;
}

.modal-fullscreen .loading {
  width: 100%;
  height: 100%;
  background-color: #ffff;
  position: fixed;
  top: 0;
  z-index: 3;
}

.progress-icon {
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  top: 250px;
  width: 70px;
  height: 70px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

input[type='datetime-local']::-webkit-calendar-picker-indicator {
  position: absolute;
  right: 5%;
  padding-left: 90%;
  cursor: pointer;
}
</style>
